import React from 'react';
import { FlagPredicate } from '../types';
import { useFlag } from '../hooks/useFlag';

export interface Props {
  condition: string | FlagPredicate;
  render?: () => React.ReactNode;
  fallbackRender?: () => React.ReactNode;
  component?: React.ComponentType<any>;
  fallbackComponent?: React.ComponentType<any>;
  [k: string]: any;
}

export const Flag: React.FC<Props> = ({
  condition,
  render,
  fallbackRender,
  component: Component,
  fallbackComponent: FallbackComponent,
  children,
  ...props
}) => {
  const isEnabled = useFlag(condition);

  if (isEnabled) {
    if (render) {
      return <>{render()}</>;
    }
    if (Component) {
      return <Component {...props}>{children}</Component>;
    }
    return <>{children}</>;
  }

  if (fallbackRender) {
    return <>{fallbackRender()}</>;
  }

  if (FallbackComponent) {
    return <FallbackComponent {...props}>{children}</FallbackComponent>;
  }

  return null;
};
Flag.displayName = 'Flag';

export default Flag;
